<template>
  <div class="email-send">
    <div class="email-send__body">
      <img class="email-send__figure" src="/static/img/mail_icon.svg" />
      <p class="email-send__lead">メールアドレス変更用URLを送信しました。<br>メールに記載されているURLにアクセスし、メールアドレスの変更を行ってください。</p>
      <p class="email-send__note">※お手続きは速やかに。24時間以内にアクセスがなかった場合、URLは無効となります。</p>
    </div>
    <div class="email-send__foot">
      <h3 class="email-send__subheading">メールが届かない場合</h3>
      <p class="email-send__description">
        メールの設定により、迷惑メールに振り分けられている可能性がありますので、迷惑メールフォルダをご確認ください。<br>
        キャリアメールをご利用の方は未登録の宛先からの受信を拒否する設定になっている可能性がありますので、info@uranai.tvからのメールを受信するよう設定の変更をお願いします。
      </p>
      <base-button
        class="email-send__button"
        tag="a"
        label="OK"
      />
    </div>
  </div>
</template>

<script>
import BaseButton from '../common/BaseButton'

export default {
  name: 'UserAccountEmailSend',
  components: {
    BaseButton
  },
}
</script>

<style lang="scss" scoped>
@import '../../../../sass/commons/commonVariables.scss';

.email-send {
  padding: 35px 4px 20px;
  color: $col_base_black;
  line-height: 1.6;
  &__body {
    padding: 0 0 30px;
  }
  &__figure {
    display: block;
    margin: 0 auto 30px;
  }
  &__lead {
    font-size: 13px;
    text-align: justify;
    margin: 0 0 5px;
  }
  &__note {
    margin: 0;
    color: $col_temp_key1;
    font-size: 11px;
    text-align: justify;
  }
  &__foot {}
  &__subheading {
    font-size: 12px;
    font-weight: 400;
    margin: 0 -20px 16px;
    padding: 8px 20px;
    background: linear-gradient(56.98deg, #FFF3F5 21.4%, #F9F4FD 76.64%);
  }
  &__description {
    margin: 0 0 25px;
    font-size: 11px;
    text-align: justify;
  }
}
</style>

<style lang="scss">
.email-send .baseButton__button {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/User/UserAccountEmailSend.vue